import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-equilibrar',
  templateUrl: './equilibrar.component.html',
  styleUrls: ['./equilibrar.component.sass']
})
export class EquilibrarComponent implements OnInit {

  constructor() { }
  public selectBan;
  @Input() billDueDateField;
  @Input() billDateField;
  @Input() lastPaymentAmountField;
  @Input() billBalanceField;
  @Input() currentList;
  @Input() cr;
  @Output() updateinitializeData = new EventEmitter();
  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
  }
  refreshDataTo(event: Event) {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.updateinitializeData.emit(); 
  }
}